// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"195":"build/css/editor-styles","255":"build/css/app","374":"build/css/components","882":"build/css/video-player"}[chunkId] + ".css";
};